import { FieldBase } from '@/components/form';
import { InfoPopover } from '@/components/ui/info';
import { Auszahlungsgrenze } from '@/domain/mitarbeiter/features/anlageassistent/content/Bezahlung/Arbeitszeitkonto/Auszahlungsgrenze';
import { AuszahlungsgrenzeEinheit } from '@/domain/mitarbeiter/features/anlageassistent/content/Bezahlung/Arbeitszeitkonto/AuszahlungsgrenzeEinheit';
import { Richtwert } from '@/domain/mitarbeiter/features/anlageassistent/content/Bezahlung/Arbeitszeitkonto/Richtwert';
import { RichtwertEinheit } from '@/domain/mitarbeiter/features/anlageassistent/content/Bezahlung/Arbeitszeitkonto/RichtwertEinheit';
import { RichtwertToggle } from '@/domain/mitarbeiter/features/anlageassistent/content/Bezahlung/Arbeitszeitkonto/RichtwertToggle';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { Toggle } from '@e2n/ui';
import { useTranslation } from 'react-i18next';

// oxlint-disable-next-line max-lines-per-function
export function ArbeitszeitkontoStundenlohn() {
  const form = useAnlageassistentFormContext();
  const { ctx } = useAnlageassistentContext();
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-10">
      <div className="flex flex-col gap-4">
        <div className="flex gap-1 items-center">
          <span className="text-neutrals-900 text-xl font-bold leading-7">
            {t(
              'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.auszahlungsgrenze.description',
            )}
          </span>
          <InfoPopover
            text={t(
              'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.auszahlungsgrenze.info',
            )}
          />
        </div>
        <div>
          <form.AppField
            name="bezahlung.arbeitszeitkonto.stundenloehner.auszahlungsgrenze"
            listeners={{
              onChange() {
                ctx.resetDependentFields(
                  'bezahlung.arbeitszeitkonto.stundenloehner.auszahlungsgrenze',
                );
              },
            }}>
            {(field) => (
              <FieldBase>
                <div className="col-span-2 grid md:grid-cols-2 items-start gap-4">
                  <Toggle
                    pressed={field.state.value === true}
                    onPressedChange={() => field.handleChange(true)}
                    variant={'outline'}
                    className="flex items-center justify-start gap-2 p-4 h-auto">
                    {t(
                      'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.auszahlungsgrenze.options.true',
                    )}
                  </Toggle>
                  <Toggle
                    pressed={field.state.value === false}
                    onPressedChange={() => field.handleChange(false)}
                    variant={'outline'}
                    className="flex items-center justify-start gap-2 p-4 h-auto">
                    {t(
                      'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.auszahlungsgrenze.options.false',
                    )}
                  </Toggle>
                </div>
              </FieldBase>
            )}
          </form.AppField>
        </div>
      </div>
      <form.Subscribe
        selector={(state) => ({
          auszahlungsgrenze:
            state.values.bezahlung.arbeitszeitkonto.stundenloehner
              ?.auszahlungsgrenze,
        })}>
        {({ auszahlungsgrenze }) => (
          <>
            {auszahlungsgrenze === true && <AuszahlungsgrenzeEinheit />}
            {auszahlungsgrenze === false && <RichtwertToggle />}
          </>
        )}
      </form.Subscribe>
      <form.Subscribe
        selector={(state) => ({
          richtwert:
            state.values.bezahlung.arbeitszeitkonto.stundenloehner?.richtwert,
        })}>
        {({ richtwert }) => <>{richtwert === true && <RichtwertEinheit />}</>}
      </form.Subscribe>
      <form.Subscribe
        selector={(state) => ({
          auszahlungsgrenzeEinheit:
            state.values.bezahlung.arbeitszeitkonto.stundenloehner
              ?.auszahlungsgrenzeEinheit,
          richtwertEinheit:
            state.values.bezahlung.arbeitszeitkonto.stundenloehner
              .richtwertEinheit,
        })}>
        {({ auszahlungsgrenzeEinheit, richtwertEinheit }) => (
          <>
            {auszahlungsgrenzeEinheit !== null && <Auszahlungsgrenze />}
            {richtwertEinheit !== null && <Richtwert />}
          </>
        )}
      </form.Subscribe>
    </div>
  );
}
